export default __webpack_public_path__ + "static/media/illustration-hero.73032583.svg";